import dashboard from "../../images/icons/dashboard1.png";
import administrator from "../../images/icons/administrator1.png";
import shield from "../../images/icons/shield1.png";
import paymentLink from "../../images/icons/paymentLink.png";
import coupons from "../../images/icons/coupons.png";
import cms from "../../images/icons/cms.png";
import customerService from "../../images/icons/customer-service.png";
import category from "../../images/icons/category.png";
import subcategory from "../../images/icons/subcategory.png";
import users from "../../images/icons/users.png";
import products from "../../images/icons/products.png";
import banner from "../../images/icons/slider.png";
import order from "../../images/icons/order.png";
import landingPage from "../../images/icons/landing-page.png";

export const MenuList = [
	// Dashboard
	{
		title: "Dashboard",
		classsChange: "mm-title",
		iconStyle: <img src={dashboard} width={22} height={22} alt="dashboard" />,
		to: "dashboard",
		text: "dashboard",
		role: "",
	},
	// Admins
	{
		title: "Admins Management",
		classsChange: "mm-title",
		iconStyle: (
			<img src={administrator} width={22} height={22} alt="administrator" />
		),
		to: "admins",
		text: "admins",
		role: "admin",
	},
	// Roles
	{
		title: "Roles",
		classsChange: "mm-title",
		iconStyle: <img src={shield} width={22} height={22} alt="shield" />,
		to: "roles",
		text: "roles",
		role: "roles",
	},
	// Users
	{
		title: "Users",
		classsChange: "mm-title",
		iconStyle: <img src={users} width={22} height={22} alt="users" />,
		to: "users",
		text: "users",
		role: "users",
	},
	// Categories
	{
		title: "Categories",
		classsChange: "mm-title",
		iconStyle: <img src={category} width={22} height={22} alt="category" />,
		text: "categories",
		to: "categories",
		role: "categories",
	},
	// SubCategories
	{
		title: "SubCategories",
		classsChange: "mm-collapse",
		iconStyle: (
			<img src={subcategory} width={22} height={22} alt="subcategory" />
		),
		to: "sub-categories",
		text: "sub_categories",
		role: "subcategories",
	},
	// Products
	{
		title: "Products",
		classsChange: "mm-title",
		iconStyle: <img src={products} width={22} height={22} alt="products" />,
		text: "products",
		to: "products",
		role: "products",
	},

	// Orders
	{
		title: "Orders",
		classsChange: "mm-collapse",
		iconStyle: <img src={order} width={22} height={22} alt="order" />,
		to: "orders",
		text: "orders",
		role: "order",
	},
	// Orders Guest
	{
		title: "Orders Guest",
		classsChange: "mm-collapse",
		iconStyle: <img src={order} width={22} height={22} alt="order" />,
		to: "orders-guest",
		text: "orders_guest",
		role: "guest_order",
	},
	// Promo Codes
	{
		title: "Promo Codes",
		classsChange: "mm-collapse",
		iconStyle: <img src={coupons} width={22} height={22} alt="coupons" />,
		to: "promo-codes",
		text: "promo_codes",
		role: "promo_code",
	},
	// Banners
	{
		title: "Banners",
		classsChange: "mm-collapse",
		iconStyle: <img src={banner} width={22} height={22} alt="banner" />,
		to: "banners",
		text: "banners",
		role: "banner",
	},
	// Payment Link
	{
		title: "Payment Link",
		classsChange: "mm-collapse",
		iconStyle: (
			<img src={paymentLink} width={22} height={22} alt="paymentLink" />
		),
		to: "payment-link",
		text: "payment_link",
		role: "payment_link",
	},
	// Contact Us
	{
		title: "Contact Us",
		classsChange: "mm-collapse",
		iconStyle: (
			<img src={customerService} width={22} height={22} alt="customerService" />
		),
		text: "contact_us",
		to: "contact-us",
		role: "contact_us",
	},
	// Landing Page
	{
		title: "Landing Page",
		text: "landing_page",
		classsChange: "mm-collapse",
		iconStyle: (
			<img src={landingPage} width={22} height={22} alt="landingPage" />
		),
		content: [
			{
				title: "Page",
				text: "page",
				to: "home-page",
				role: "landing_page",
			},
			{
				title: "Leadership",
				text: "leadership",
				to: "leadership",
				role: "landing_page",
			},
		],
	},
	// CMS
	{
		title: "CMS",
		text: "cms",
		classsChange: "mm-collapse",
		iconStyle: <img src={cms} width={22} height={22} alt="cms" />,
		content: [
			{
				title: "Delivery",
				text: "delivery",
				to: "delivery",
				role: "payment_link",
			},
			{
				title: "Social Media",
				text: "social_media",
				to: "social",
				role: "contact_us",
			},
			{
				title: "About Us",
				text: "about_us",
				to: "about-us",
				role: "about_us",
			},
			{
				title: "Privacy",
				text: "privacy",
				to: "privacy",
				role: "privacy_and_policy",
			},
			{
				title: "Terms and Conditions",
				text: "terms_and_conditions",
				to: "terms_and_conditions",
				role: "terms_and_conditions",
			},
		],
	},
];
